<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelSuiviHeures popup="popup" [model]="contenuMenuContextuelSuiviHeures"></p-menu>
<p-toast></p-toast>

<p-card>
    <p-tabMenu [model]="items" [(activeItem)]="activeItem" styleClass="mb-4"></p-tabMenu>

    <p-card *ngIf="!EstCharge()">
        <div class="fluid formgrid grid">
            <div class="flex flex-column gap-2 my-2 col-12 text-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
    </p-card>

    <div *ngIf="EstCharge()" class="card">
        <div class="grid ">
            <div class="col-12 md:col-6 lg:col-3">
                <p-card styleClass="h-full">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">Sans relevé récent</span>
                            <div class="text-900 font-medium text-xl">{{ activeTab() === 'heures' ? getNombreItemsSansReleveRecent() : getNombreItemsSansReleveRecentKms()}}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-red-50 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-exclamation-circle text-red-500 text-xl"></i>
                        </div>
                    </div>
                    <span class="text-600 font-medium">{{( (activeTab() === 'heures' ? getNombreItemsSansReleveRecent() : getNombreItemsSansReleveRecentKms()) / (activeTab() === 'heures' ? suiviHeures.length : suiviKms.length) * 100) |
                        number:'1.0-0'}}% </span>
                    <span class="text-500">des équipements</span>
                    <div class="mt-3">
                        <button *ngIf="!filtreSansReleveRecent" pButton pRipple label="Filtrer"
                            class="p-button-outlined p-button-sm" (click)="filtrerSansReleveRecent(dt)"></button>
                        <button *ngIf="filtreSansReleveRecent" pButton pRipple label="Réinitialiser"
                            class="p-button-outlined p-button-sm"
                            (click)="reinitialiserFiltreSansReleveRecent(dt)"></button>
                    </div>
                </p-card>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <p-card styleClass="h-full">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">En location</span>
                            <div class="text-900 font-medium text-xl">{{getNombreItemsAvecLocation()}}</div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-blue-50 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-tag text-blue-500 text-xl"></i>
                        </div>
                    </div>
                    <span class="text-600 font-medium">{{(getNombreItemsAvecLocation() / suiviHeures.length * 100) |
                        number:'1.0-1'}}% </span>
                    <span class="text-500">des équipements</span>
                    <div class="mt-3">
                        <button *ngIf="!filtreAvecLocation" pButton pRipple label="Filtrer"
                            class="p-button-outlined p-button-sm" (click)="filtrerAvecLocation(dt)"></button>
                        <button *ngIf="filtreAvecLocation" pButton pRipple label="Réinitialiser"
                            class="p-button-outlined p-button-sm"
                            (click)="reinitialiserFiltreAvecLocation(dt)"></button>
                    </div>
                </p-card>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <p-card styleClass="h-full">
                    <div class="flex justify-content-between mb-3">
                        <div>
                            <span class="block text-500 font-medium mb-3">{{ activeTab() === 'heures' ? 'Différence moyenne en heures' : 'Différence moyenne en km' }}</span>
                            <div class="text-900 font-medium text-xl">{{ activeTab() === 'heures' ? (calculerHeuresMoyennes() | number:'1.0-2') : (calculerKmsMoyens() | number:'1.0-2')}} {{ activeTab() === 'heures' ? 'h' : 'km' }}
                            </div>
                        </div>
                        <div class="flex align-items-center justify-content-center bg-orange-50 border-round"
                            style="width:2.5rem;height:2.5rem">
                            <i class="pi pi-clock text-orange-500 text-xl"></i>
                        </div>
                    </div>
                    <span class="text-500">Utilisation moyenne par équipement pour les {{activeTab() === 'heures' ? 'heures' : 'km'}} pris en compte</span>
                </p-card>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <p-card styleClass="h-full">
                    <div class="mb-3">
                        <span class="block text-500 font-medium mb-3">Répartition des différences {{activeTab() === 'heures' ? 'd\'heures' : 'de km'}}</span>
                    </div>
                    <p-chart type="bar" [data]="chartData" [options]="chartOptions" height="120px"></p-chart>
                </p-card>
            </div>
        </div>

        <p-messages severity="info" [closable]="false" [sticky]="true">
            <ng-template pTemplate>
                <div class="flex align-items-center gap-2">
                    <span class="pi pi-info-circle"></span>
                    <span>Les équipements qui n'ont pas de prises d'heures depuis une semaine sont en rouge.</span>
                </div>
            </ng-template>
        </p-messages>

        <div class="mt-4">
            <p-table #dt [value]="activeTab() === 'heures' ? suiviHeures : suiviKms" [paginator]="true" [rows]="10" [(columns)]="colonnesSelectionnees" 
                [rowsPerPageOptions]="[10,25,50,100]" [showCurrentPageReport]="true" [rowHover]="true" sortMode="multiple" [multiSortMeta]="multiSortMeta"
                [globalFilterFields]="['item.numero', 'item.description', 'item.sousCategorie.nom', 'item.emplacement.nom', 'differenceJours', activeTab() === 'heures' ? 'differenceHeures' : 'differenceKms', 'location.dateDebut', 'location.dateFin', 'location.heuresDebut', 'location.fournisseur.nom', 'location.typeLocation.nom', 'location.nbHeuresParMois']"
                currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} enregistrements" 
                styleClass="p-datatable-sm" [tableStyle]="{'min-width': '50rem'}">

                <ng-template pTemplate="caption">
                    <div class="flex justify-content-between flex-wrap">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" placeholder="Rechercher..."
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')" />
                        </span>
                        <div class="flex flex-wrap gap-2">
                            <p-multiSelect [options]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                                optionLabel="entete" selectedItemsLabel="{0} colonnes sélectionnées"
                                [style]="{minWidth: '200px'}" placeholder="Sélectionner les colonnes"
                                (onChange)="onToggle()">
                                <ng-template let-col pTemplate="item">
                                    <div class="p-multiselect-column-item">
                                        <span>{{col.entete}}</span>
                                    </div>
                                </ng-template>
                            </p-multiSelect>
                            <button pButton label="Rafraîchir" icon="pi pi-refresh" class="p-button-outlined"
                                (click)="chargerDonnees()"></button>
                        </div>
                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="EstColonneSelectionnee('numero')" pSortableColumn="item.numero">Numéro <p-sortIcon
                                field="item.numero"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('description')" pSortableColumn="item.description">Description
                            <p-sortIcon field="item.description"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('sousCategorie')" pSortableColumn="item.sousCategorie.nom">Sous-catégorie
                            <p-sortIcon field="item.sousCategorie.nom"></p-sortIcon></th>    
                        <th *ngIf="EstColonneSelectionnee('emplacement')" pSortableColumn="item.emplacement.nom">
                            Emplacement <p-sortIcon field="item.emplacement.nom"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('dateDebut')" pSortableColumn="dateDebut">Date début
                            <p-sortIcon field="dateDebut"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('avantDerniereLecture')"
                            pSortableColumn="dateAvantDernierePrise">Avant-dernière lecture <p-sortIcon
                                field="dateAvantDernierePrise"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('derniereLecture')" pSortableColumn="dateDernierePrise">
                            Dernière lecture <p-sortIcon field="dateDernierePrise"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('difference')">
                            <div class="flex justify-content-between align-items-center">
                                <div class="flex align-items-center gap-2">
                                    <span>Différence</span>
                                    <button type="button" pButton icon="pi pi-sort" class="p-button-text"
                                        (click)="op.toggle($event)"></button>
                                    <p-overlayPanel #op>
                                        <p-dropdown [options]="orderByDifferenceOptions"
                                            [(ngModel)]="selectedOrderByDifference" styleClass="p-button-text"
                                            optionLabel="label" optionValue="" [showClear]="false"
                                            (onChange)="onDifferenceFilterChange($event)">
                                            <ng-template let-option pTemplate="item">
                                                {{option.label}}
                                            </ng-template>
                                        </p-dropdown>
                                    </p-overlayPanel>
                                </div>
                            </div>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateDebutLocation') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.dateDebut">Date début location <p-sortIcon
                                field="location.dateDebut"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('dateFinLocation') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.dateFin">Date fin location <p-sortIcon
                                field="location.dateFin"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('heuresDebut') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.heuresDebut">Heures début <p-sortIcon
                                field="location.heuresDebut"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('fournisseur') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.fournisseur.nom">Fournisseur <p-sortIcon
                                field="location.fournisseur.nom"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('typeLocation') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.typeLocation.nom">Type location <p-sortIcon
                                field="location.typeLocation.nom"></p-sortIcon></th>
                        <th *ngIf="EstColonneSelectionnee('nbHeuresParMois') && EstColonneSelectionnee('location')"
                            pSortableColumn="location.nbHeuresParMois">Heures/mois <p-sortIcon
                                field="location.nbHeuresParMois"></p-sortIcon></th>
                        <th></th>
                    </tr>
                    <tr>
                        <th *ngIf="EstColonneSelectionnee('numero')">
                            <p-columnFilter type="text" field="item.numero" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('description')">
                            <p-columnFilter type="text" field="item.description" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('sousCategorie')">
                            <p-columnFilter type="text" field="item.sousCategorie.nom" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('emplacement')">
                            <p-columnFilter type="text" field="item.emplacement.nom" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateDebut')">
                            <p-columnFilter type="date" field="dateDebut" matchMode="dateIs"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('avantDerniereLecture')">
                            <p-columnFilter type="date" field="dateAvantDernierePrise" matchMode="dateIs"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('derniereLecture')">
                            <p-columnFilter type="date" field="dateDernierePrise" matchMode="dateIs"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('difference')">
                            <p-columnFilter type="numeric" [field]="activeTab() === 'heures' ? 'differenceHeures' : 'differenceKms'" matchMode="equals"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateDebutLocation') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="date" field="location.dateDebut" matchMode="dateIs"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('dateFinLocation') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="date" field="location.dateFin" matchMode="dateIs"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('heuresDebut') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="numeric" field="location.heuresDebut" matchMode="equals"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('fournisseur') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="text" field="location.fournisseur.nom" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('typeLocation') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="text" field="location.typeLocation.nom" matchMode="contains"></p-columnFilter>
                        </th>
                        <th *ngIf="EstColonneSelectionnee('nbHeuresParMois') && EstColonneSelectionnee('location')">
                            <p-columnFilter type="numeric" field="location.nbHeuresParMois" matchMode="equals"></p-columnFilter>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-suivi>
                    <tr [ngClass]="{'bg-red-100 hover:bg-red-200': estDernierePriseAncienne(suivi)}">
                        <td *ngIf="EstColonneSelectionnee('numero')">
                            <button pButton pRipple class="p-button-text p-button-plain"
                                [routerLink]="['/item', suivi.item?.itemId]">
                                {{suivi.item?.numero}}
                            </button>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('description')">{{suivi.item?.description}}</td>
                        <td *ngIf="EstColonneSelectionnee('sousCategorie')">{{suivi.item?.sousCategorie?.nom}}</td>
                        <td *ngIf="EstColonneSelectionnee('emplacement')">
                            <button *ngIf="suivi.item?.emplacement?.emplacementId" pButton pRipple
                                class="p-button-text p-button-plain"
                                [routerLink]="['/pilotage/emplacement', suivi.item?.emplacement?.emplacementId]">
                                {{suivi.item?.emplacement?.nom}}
                            </button>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('dateDebut')">{{suivi.dateDebut | date:'dd/MM/yyyy'}}</td>
                        <td *ngIf="EstColonneSelectionnee('avantDerniereLecture')">
                            <div class="flex flex-column">
                                <div class="flex align-items-center mb-1">
                                    <i class="pi pi-calendar text-primary mr-2"></i>
                                    <span>{{suivi.dateAvantDernierePrise | date:'dd/MM/yyyy' | valeurVide}}</span>
                                </div>
                                <div class="flex align-items-center">
                                    <i class="pi pi-clock text-primary mr-2"></i>
                                    <span class="font-medium">{{ (activeTab() === 'heures' ?
                                        suivi.heuresAvantDernierePrise : suivi.kmsAvantDernierePrise) | number:'1.0-2' |
                                        valeurVide}} {{activeTab() === 'heures' ? 'h' : 'km'}}</span>
                                </div>
                            </div>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('derniereLecture')">
                            <div class="flex flex-column">
                                <div class="flex align-items-center mb-1">
                                    <i class="pi pi-calendar text-primary mr-2"></i>
                                    <span>{{suivi.dateDernierePrise | date:'dd/MM/yyyy' | valeurVide}}</span>
                                </div>
                                <div class="flex align-items-center">
                                    <i class="pi pi-clock text-primary mr-2"></i>
                                    <span class="font-medium">{{ (activeTab() === 'heures' ?
                                        suivi.heuresDernierePrise : suivi.kmsDernierePrise) | number:'1.0-2' |
                                        valeurVide}} {{activeTab() === 'heures' ? 'h' : 'km'}}</span>
                                </div>
                            </div>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('difference')">
                            <div class="flex flex-column align-items-center justify-content-center">
                                <span class="font-bold text-lg"
                                    [ngClass]="activeTab() === 'heures' ? getClassDifference(calculerDifferenceHeures(suivi)) : getClassDifference(calculerDifferenceKms(suivi))">
                                    <i *ngIf="activeTab() === 'heures' ? (calculerDifferenceHeures(suivi) > 0) : (calculerDifferenceKms(suivi) > 0)"
                                        class="pi pi-arrow-up mr-1"></i>
                                    <i *ngIf="activeTab() === 'heures' ? (calculerDifferenceHeures(suivi) < 0) : (calculerDifferenceKms(suivi) < 0)"
                                        class="pi pi-arrow-down mr-1"></i>
                                    {{activeTab() === 'heures' ? calculerDifferenceHeures(suivi) :
                                    calculerDifferenceKms(suivi)}} {{activeTab() === 'heures' ? 'h' : 'km'}}
                                </span>
                                <span class="text-500 text-sm"
                                    *ngIf="suivi.dateAvantDernierePrise && suivi.dateDernierePrise">
                                    {{calculerDifferenceJours(suivi)}} jours
                                </span>
                            </div>
                        </td>
                        <td *ngIf="EstColonneSelectionnee('dateDebutLocation') && EstColonneSelectionnee('location')">
                            {{suivi.location?.dateDebut | date:'dd/MM/yyyy' | valeurVide}}</td>
                        <td *ngIf="EstColonneSelectionnee('dateFinLocation') && EstColonneSelectionnee('location')">
                            {{suivi.location?.dateFin | date:'dd/MM/yyyy' | valeurVide}}</td>
                        <td *ngIf="EstColonneSelectionnee('heuresDebut') && EstColonneSelectionnee('location')">
                            {{suivi.location?.heuresDebut | number:'1.0-2' | valeurVide}} h</td>
                        <td *ngIf="EstColonneSelectionnee('fournisseur') && EstColonneSelectionnee('location')">
                            {{suivi.location?.fournisseur?.nom | valeurVide}}</td>
                        <td *ngIf="EstColonneSelectionnee('typeLocation') && EstColonneSelectionnee('location')">
                            {{suivi.location?.typeLocation?.nom | valeurVide}}</td>
                        <td *ngIf="EstColonneSelectionnee('nbHeuresParMois') && EstColonneSelectionnee('location')">
                            {{suivi.location?.nbHeuresParMois | number:'1.0-2' | valeurVide}} h</td>
                        <td>
                            <button pButton pRipple class="p-button-secondary boutonGrille" icon="pi pi-bars"
                                (click)="surMenuContextuelSuivi(suivi)"></button>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="13" class="text-center">Aucune donnée trouvée</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-card>